import 'focus-within-polyfill';

import './global/jquery-migrate';
import './common/select-option-plugin';
import PageManager from './page-manager';
import quickSearch from './global/quick-search';
import currencySelector from './global/currency-selector';
import mobileMenuToggle from './global/mobile-menu-toggle';
import menu from './global/menu';
import foundation from './global/foundation';
import quickView from './global/quick-view';
import cartPreview from './global/cart-preview';
import carousel from './common/carousel';
import svgInjector from './global/svg-injector';
import collapsibleFactory from './common/collapsible';

import obMegaMenu from './ob-custom/ob-mega-menu';
import obAccountMenu from './ob-custom/ob-account-menu';
import obHeaderPromo from './ob-custom/ob-header-promo';
import obCardOptions from './ob-custom/ob-card-options';
//import obQuickSearch from './ob-custom/ob-quick-search';
import obProductsPerPage from './ob-custom/ob-products-per-page';
import obCartSlideout from './ob-custom/ob-cart-slideout';
import obMobileCategoryGrid from './ob-custom/ob-mobile-category-grid';
import obBlogCarousel from './ob-custom/ob-blog-carousel';
import obRentalCarousel from './ob-custom/ob-rental-carousel';
import obProductCarouselWithFilters from './ob-custom/widgets/ob-product-carousel-with-filters';

export default class Global extends PageManager {
    onReady() {
        const { cartId, secureBaseUrl } = this.context;
        cartPreview(secureBaseUrl, cartId);
        quickSearch();
        currencySelector(cartId);
        foundation($(document));
        quickView(this.context);
        carousel(this.context);
        menu();
        mobileMenuToggle();
        svgInjector();

        // Init collapsible
        collapsibleFactory();
        obCartSlideout(this.context);
        //obQuickSearch(this.context);
        obMegaMenu(this.context);
        obProductCarouselWithFilters();
        obAccountMenu();
        obCardOptions(this.context);
        obProductsPerPage(this.context);
        obHeaderPromo(this.context);
        obMobileCategoryGrid();
        obBlogCarousel();
        obRentalCarousel(this.context);
    }
}
